import { getPlanningCycleStatusConfig } from '../../types/PlanningObjectiveStatus';
import { getPlanningObjectiveStatusConfig } from '../../types/PlanningObjectiveStatus';
import { getPlanningWorkItemStatusConfig } from '../../types/PlanningObjectiveStatus';

type PlanningStatusBadgeProps = {
  scope: 'cycle' | 'objective' | 'workItem';
  status: string;
};

export function PlanningStatusBadge({ scope, status }: PlanningStatusBadgeProps) {
  const config =
    scope === 'cycle'
      ? getPlanningCycleStatusConfig(status)
      : scope === 'objective'
        ? getPlanningObjectiveStatusConfig(status)
        : getPlanningWorkItemStatusConfig(status);

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${config.className}`}
    >
      {config.label}
    </span>
  );
}
